export const TableElementEpc = ({ epc }: { epc: string }) => (
  <div className="flex flex-col items-center">
    <div>{epc.slice(0, 16)}</div>
    <div>{epc.slice(16)}</div>
  </div>
)
